import './styles.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import QuestionMark from 'components/QuestionMark';

const propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  checked: PropTypes.bool,
  questionMark: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool
};
const defaultProps = {
  className: '',
  checked: false,
  required: false
};

class Checkbox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isCheckedByKeyNavigation: false
    };
  }

  render() {
    const { className, id, name, checked, onChange, label, questionMark, required } = this.props;

    const handleKeyDown = e => {
      if (e.code === 'Space') {
        const { isCheckedByKeyNavigation } = this.state;
        // if we don't prevent default, the page will scroll
        e.preventDefault();
        e.target.checked = !isCheckedByKeyNavigation;
        onChange(e);
        this.setState({ isCheckedByKeyNavigation: !isCheckedByKeyNavigation });
      }
    };

    return (
      <div className={`${className}`}>
        <div className="checkbox-wrapper" tabIndex={0} onKeyDown={handleKeyDown}>
          <label htmlFor={id} className="checkbox-wrapper__text">
            <input type="checkbox" id={id} name={name} checked={checked} onChange={onChange} required={required} />
            <label htmlFor={id} className="checkbox-wrapper__label" />
            <span>{label}</span>
          </label>
          {questionMark && <QuestionMark content={questionMark} />}
        </div>
      </div>
    );
  }
}

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;

export default Checkbox;
